<div class="search-telnyx-number-form">
  <app-switcher
    [items]="numberTypeSwitcherOptions"
    [activeItem]="numberType"
    (switcherChange)="changeNumberType($event)"
  ></app-switcher>

  <div class="paper search-telnyx-number-form__section">
    <input
      [placeholder]="numberSearchInputPlaceholder"
      [ngModel]="numberSearchString"
      (ngModelChange)="onSearchStringChange($event)"
      required
      class="form-input_md"
    />
  </div>

  <div class="paper search-telnyx-number-form__section">
    <p *ngIf="showSelectedNumber" class="form-input_md">
      {{ selectedNumber || "Select number..." }}
    </p>

    <ul
      #telnyxNumberListRef
      class="search-telnyx-number-form__number-list"
      [class.search-telnyx-number-form__number-list_active]="showTelnyxNumbers"
      (scroll)="getMoreTelnyxNumbersOnScrollEnd()"
    >
      <li *ngFor="let telnyxNumber of matchingTelnyxNumbers">
        <button class="btn btn_xs" (click)="onSelectNumber(telnyxNumber.number)">
          {{ telnyxNumber.number }}
        </button>
      </li>
    </ul>
  </div>
</div>
